import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import useTemplateId from './useTemplateId'
import { config } from 'lib/config'
import { store } from 'lib/store'
import type { GetIntegrationData, IntegrationName } from 'types/integrations'

export function useIntegration<Name extends IntegrationName>(name: Name, options?: SWRConfiguration) {
	const { withTemplateId } = useTemplateId()

	const { data, mutate, isLoading, error } = useSWR<GetIntegrationData[Name]>(
		withTemplateId(`${config.apiURL}/v1.0/integrations/${name}`),
		options,
	)

	if (error) {
		store.dispatch({
			type: 'toast/set',
			payload: { kind: 'error', timeout: 6000, message: 'Something went wrong' },
		})
	}

	return {
		integration: data,
		mutateIntegration: mutate,
		isIntegrationLoading: isLoading,
	}
}
